import {Headers, Http, Response, URLSearchParams} from '@angular/http';

import {ErrorHandler} from '../restapi/error-handler';
import {UserService} from '../user/user.service';
import {Injectable} from '@angular/core';
import {TrialRegistration} from './trial';
import {AwsEnvironment} from '../aws/environment';
import {Observable} from 'rxjs/Rx';
import {Message} from '../publisher/message';
import {Subject} from 'rxjs/Subject';
import {AwsHttp} from '../aws/http';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';


@Injectable()
export class TrialService {

    public createAccountCredentials = new Subject<any>();
    public trialStatusChanged = new BehaviorSubject<any>({trialMode: false, trialModeExpired: false, trialData: '', max: ''});
    public thresholdExceeded = new Subject<any>();

    trialMode: boolean = false;
    trialModeExpired: boolean = false;
    trialData: string;
    max: any;

    estimatedOutboundData: any;
    consume: any;
    threshold: any;


    constructor(

        private errorHandler: ErrorHandler,
        private awsEnv: AwsEnvironment,
        private http: Http,
        private awsHTTP: AwsHttp,
        private userService: UserService
    ) {
    }

    postTrialRegistration(registrationParams: TrialRegistration): Observable<any> {
        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let baseRegistrationUrl = this.awsEnv.getRegistrationUrl();
        let url = `${baseRegistrationUrl}/account/create`;
        return this.http
            .post(url, JSON.stringify(registrationParams), { headers: headers })
            .map((response: Response) => response.json())
            .catch((response: Response) => this.errorHandler.throwError(response))

    }

    pollTrialRegistration(reqID: any) {

        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let params = new URLSearchParams(reqID);

        let baseRegistrationUrl = this.awsEnv.getRegistrationUrl();
        let url = `${baseRegistrationUrl}/account/create?ReqId=`+reqID;

        let obs = Observable.interval(5000)
            .switchMap(() => this.http.get(url , { headers: headers})).map((data) => data.json())
            .subscribe((data) => {
                //console.log(data);// see console you get output every 5 sec
                if(data === 'CREATED' || data === 'FAILED' || data === 'DELETED'){
                    obs.unsubscribe(); //stop polling
                    this.createAccountCredentials.next(data);
                }
            });
    }

    accountActivation(email: any, code: any): Observable<any>  {
        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let params = {
            Email: email,
            PromoCode: code
        };
        let baseRegistrationUrl = this.userService.getApiUrl();
        let url = `${baseRegistrationUrl}/account/activate`;
        return this.awsHTTP
            .post(url, JSON.stringify(params), { headers: headers })
            .map((response: Response) => response.json())
            .catch((response: Response) => this.errorHandler.throwError(response))
    }

    accountStatus(email: string): Observable<any>  {
        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let params = {
            Email: email
        };

        let baseRegistrationUrl = this.userService.getApiUrl();
        let url = `${baseRegistrationUrl}/account/status`;
        return this.awsHTTP
            .get(url, { headers: headers })
            .map((response: Response) => response.json())
            .catch((response: Response) => this.errorHandler.throwError(response))
    }


    getAccountStatus(email: string) {
        this.accountStatus(email)
            .subscribe(
                (response) => {
                    let trialStatus = {};
                    if(response.trial){
                        this.trialMode = response.trial;
                        this.max = response.max;
                        trialStatus = {
                            trialMode: response.trial,
                            trialModeExpired: response.expired,
                            trialData: this.bytesToSize(response.remaining),
                            max: response.max
                        }
                    }else{
                        this.consume = parseFloat(((response.consume / 1000000) / 1000).toFixed(2));
                        this.threshold = parseFloat(((response.threshold / 1000000) / 1000).toFixed(2));
                        trialStatus = {
                            trialMode: response.trial,
                            consume: this.consume,
                            threshold: this.threshold
                        }
                    }

                    this.trialStatusChanged.next(trialStatus);
                    this.determineThresholdExceeded();
                    },
                (error) => {
                    console.log(error);
                    this.trialMode = false;
                }
            )
    }

    updateAccount(email: string) {
        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let baseRegistrationUrl = this.userService.getApiUrl();
        let url = `${baseRegistrationUrl}/account/update`;
        return this.awsHTTP
            .post(url, '', { headers: headers })
            .map((response: Response) => response.json())
            .catch((response: Response) => this.errorHandler.throwError(response))
    }

    bytesToSize(size: number) : string {
        var i = Math.floor( Math.log(size) / Math.log(1000) );
        if(size === 0){
            return '0 GB';
        }
        return +( size / Math.pow(1000, i) ).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
    };

    setEstimatedOutboundData(value: any) {
        this.estimatedOutboundData = parseFloat(value);
        this.determineThresholdExceeded();
    }

    determineThresholdExceeded() {
        if(!this.trialMode && this.estimatedOutboundData && this.consume && this.threshold) {
            if(this.estimatedOutboundData + this.consume > this.threshold) {
                this.thresholdExceeded.next(true);
            }else{
                this.thresholdExceeded.next(false);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/trial/trial.service.ts